import { ChameleonRequest } from "@repo/chameleon-request";

import { getApiUrl } from "@repo/utils/get-api-url";
import { SizeGuide } from "./size-guide.type";

type SizeGuideParams = {
  chameleonRequestInstance: ChameleonRequest;
  sizeGuideId: number;
};

export async function getSizeGuide({
  chameleonRequestInstance,
  sizeGuideId,
}: SizeGuideParams) {
  const url = getApiUrl({
    path: `/sizing/sizeapi/v1/SizeGuide/${sizeGuideId}/`,
  });

  const { data } = await chameleonRequestInstance.get<SizeGuide>(
    url,
    undefined,
    {
      requestType: "SIZE_GUIDE_API",
    },
  );

  return data;
}
